<template>
  <v-card class="pa-6">
    <v-card-title class="d-flex justify-space-between align-center">
      <div>Detalle de Cotización #{{ id }}</div>
      <v-btn icon class="elevation-0" @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      {{quotation}}
    </v-card-text>
  </v-card>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import { useQuotationsStore } from '@/store/quotations';
import { format } from 'date-fns';

const props = defineProps<{ id: number }>();
const store = useQuotationsStore();

const quotation = ref<any>(null);
const loading = ref(true);

onMounted(async () => {
  try {
    loading.value = true;
    quotation.value = await store.fetchQuotationById(props.id);
  } catch (e) {
    console.error('[Detail.vue] No se pudo cargar la actividad:', e);
  } finally {
    loading.value = false;
  }
});

</script>

<style scoped>
.text-caption {
  font-size: 0.75rem;
  font-weight: 500;
}
</style>